import React, { useEffect } from 'react';
import { CircularProgress, Backdrop } from "@mui/material";

export default function PaymentSuccessForTraining() {

    useEffect(() => {
        //alert(window.parent.location);
        window.top.location.href = "/EmployeesList";
    }, []);
    return (
        <div>
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
        >
            <CircularProgress color="inherit" />
        </Backdrop></div>
    )
}
